import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import '../styles/PageNotFound.css';

export const PageNotFound = () => {
  return (
    <div className="page-not-found-container">
      <DotLottieReact
        src="https://lottie.host/74353594-b8c8-4f97-90ff-76453973b52b/iZVwooQVv8.lottie"
        loop
        autoplay
      />
    </div>
  );
};
